<template>
    <div v-if="isVisible" :class="row ? 'd-flex align-center' : ''">
        <span class="font-color-light">
            <v-icon class="mr-1" dense>{{ icon }}</v-icon>
            {{ $t(label) }} :
        </span>
        <slot>
            <span class="font-weight-bold">{{ value }}</span><br />
        </slot>
    </div>
</template>

<script>
export default {
    name: 'DeviceInfoRowComponent',
    props: {
        icon: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        value: {
            default: undefined,
        },
        row: {
            type: Boolean,
            default: false,
        },
        force_visibility: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        isVisible() {
            return this.force_visibility || (this.value !== undefined && this.value !== null && this.value !== '')
        },
    },
}
</script>